module.exports = __webpack_public_path__ + "static/img/manual-23.552e02c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-23.png
// module id = PLZE
// module chunks = 4